module.exports = __webpack_public_path__ + "media/27.1cb01c24.mp4";